/* tslint:disable */
export {};
declare global {
  interface Element {
    on(event: string, cb: Function, opts?);

    off(event: string);

    eventExists(event: string);

    triggerNamespace(event: string);

    addEventListenerToAll(selector: string, event: string, callback: EventListenerOrEventListenerObject);

    addMutationObserverToChildren(selector: string, options: MutationObserverInit, callback: Function)
  }

  interface HTMLElement extends Element {
  }

  interface Window {
    on(event: string, cb: Function, opts?);

    off(event: string);

    eventExists(event: string);

    triggerNamespace(event: string);

    addEventListenerToAll(selector: string, event: string, callback: EventListenerOrEventListenerObject);

    addMutationObserverToChildren(selector: string, options: MutationObserverInit, callback: MutationCallback)

    activeXHRRequests: number
  }
}
const events = {
  /**
   * Adds a namespace or regular event listener to the window or element object Arguments follows https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener arguments
   * @param {string} event event name with a .namespace E.g. scroll.contentBody
   * @param {Function} cb Call back function
   * @param {{}} opts options for the addEventListener
   * @returns {any}
   */
  on(event: string, cb: Function, opts = {}): any {
    if (!this.namespaces) { // save the namespaces on the DOM element itself
      this.namespaces = {};
    }

    if (!this.options) { // save the options on the DOM element itself
      this.options = {};
    }

    this.namespaces[event] = cb;
    this.options[event] = opts;
    const options = opts || false;

    this.addEventListener(event.split('.')[0], cb, options);
    return this;
  },

  /**
   * Removes the namespace or regular event from the window or element
   * @param {string} event event name with or without a .namespace E.g. scroll.contentBody
   * @returns {any}
   */
  off(event: string): any {
    if (this.eventExists(event)) {
      this.removeEventListener(event.split('.')[0], this.namespaces[event], this.options[event]);
      delete this.namespaces[event];
    }
    return this;
  },

  /**
   * Triggers the namespaced event
   * @param {string} event
   * @returns {void}
   */
  triggerNamespace(event: string): void {
    if (this.eventExists(event)) {
      this.namespaces[event]();
    }
  },

  /**
   * Checks to see if the event exists
   * @param {string} event
   * @returns {boolean}
   */
  eventExists(event: string): boolean {
    return this.namespaces && this.namespaces[event];
  },

  /**
   * Adds an event listener to all children by selector
   * @param {string} selector
   * @param {string} event
   * @param {EventListenerOrEventListenerObject} callback
   */
  addEventListenerToAll(selector: string, event: string, callback: EventListenerOrEventListenerObject): void {
    const nodeList: NodeList = this.querySelectorAll(selector);

    Array.from(nodeList).forEach((elm: Element) => {
      elm.addEventListener(event, callback);
    });
  },

  addMutationObserverToChildren(selector: string, options: MutationObserverInit, callback: MutationCallback) {
    const children = this.querySelectorAll(selector);
    Array.from(children).forEach((elm: Node) => {
      const observer = new MutationObserver(callback);
      observer.observe(elm, options);
    });
  },
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = events.on;
window.off = Element.prototype.off = events.off;
window.eventExists = Element.prototype.eventExists = events.eventExists;
window.triggerNamespace = Element.prototype.triggerNamespace = events.triggerNamespace;
window.addEventListenerToAll = Element.prototype.addEventListenerToAll = events.addEventListenerToAll;
window.addMutationObserverToChildren = Element.prototype.addMutationObserverToChildren = events.addMutationObserverToChildren;

window.activeXHRRequests = 0;



// WEBPACK FOOTER //
// ./src/utils/window/window-prototype.utils.ts